<template>
  <div class="fts-list-designer-element">
    <!-- Element Wrapper -->
    <div class="list-designer-element-wrapper">
      <!-- Element Item -->
      <div class="list-designer-element-item" :class="{'selection-prefix': getSelectionPrefix}">
        <i class="list-designer-element-icon" :class="getIcon(item.type)" />
        <div class="list-designer-element-name handle">{{item.displayName}}</div>
      </div>
      <!-- Element Columns -->
      <div class="list-designer-element-columns" v-if="item.type === 14 && item.fields && item.fields.length">
        <fts-list-designer-layouter :columns="item.fields.filter(x => !x.hide)" :wrap="false" :removeable="false" />
      </div>
      <!-- Element Control -->
      <div class="list-designer-element-control">
        <div class="list-designer-element-control-container">
          <div class="list-designer-element-control-wrapper">
            <font-awesome-icon class="element-control-edit" :icon="['fas', 'edit']" fixedWidth @click="openModal" /> 
          </div>
          <div class="list-designer-element-control-wrapper" v-if="item.wrap">
            <div class="element-control-badge">TW</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Element Remove -->
    <div class="list-designer-element-remove">
      <font-awesome-icon :icon="['fas', 'times']" fixedWidth @click="remove(item)" /> 
    </div>

    <!-- Modal -->
    <fts-modal 
      class="designer-modal list-designer-element-modal"
      headerClass="designer-header"
      contentClass="designer-body"
      footerClass="designer-footer"
      @close="closeModal"
      v-if="informationModal">
      <!-- header -->
      <template #header>
        <div class="designer-header-wrapper">  
          <div class="element-modal-header">
            <i 
              class="element-modal-info-icon" 
              :class="[getIcon(item.type), {'system': getSelectionPrefix}]" />
            <div class="designer-header-title">{{item.displayName}}</div>
          </div>
          <div class="designer-header-desc">Column Designer</div>
        </div>
        <div class="designer-header-actions">
          <fts-btn text icon class="designer-header-action" @click="closeModal">
            <font-awesome-icon :icon="['fas', 'times']"/>
          </fts-btn>
        </div>
      </template>
      <!-- body -->
      <template #body>
        <fts-form :formData="formData" :form="listDesignForm" :labelTop="true" />
        <draggable class="element-modal-columns"
          v-if="formData.type === 14 && formData.fields && formData.fields.length" 
          v-model="formData.fields" 
          v-bind="dragOptions"
          handle=".element-modal-column-handle"
          draggable=".element-modal-column-wrapper"
        >      
          <div class="element-modal-column-wrapper" 
            v-for="column in formData.fields" 
            :key="column.id" 
            :class="{ 'column-selected': !column.hide }" 
            @click="column.hide ? showColumn(column) : hideColumn(column)"
          >
            <font-awesome-icon class="element-modal-column-handle" :icon="['fas', 'grip-vertical']" fixed-width @click.stop/>  
            <div class="element-modal-column-item">
              <i class="element-modal-column-icon" :class="getIcon(column.type)"/>
              <div class="element-modal-column-name">{{column.displayName}}</div>
              <div class="element-modal-column-indicator">
                <font-awesome-icon :icon="['fas', 'circle']" fixed-width v-if="column.hide" />
                <font-awesome-icon :icon="['fas', 'check-circle']" fixed-width v-else />
              </div>
            </div>
          </div>
          <div slot="header" class="element-modal-label">Columns</div>
        </draggable>   
      </template>
      <!-- footer -->
      <template #footer>
        <fts-btn text @click="closeModal">
          Cancel
        </fts-btn>
        <fts-btn color="primary" box-shadow-none @click="doneModal">
          Ok
        </fts-btn>
      </template>
    </fts-modal>
  </div>
</template>

<script>
import commons from "../commons/commons";
import queryLogic from "../commons/queryLogic";
import draggable from "vuedraggable";

import FTSForm from "../elements/FTSForm";
import FTSModal from "../elements/FTSModal";
import FTSBtn from "../elements/FTSBtn";

export default {
  props: {
    item: {
      type: Object
    },
    removeable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    draggable,
    "fts-modal": FTSModal,
    "fts-form": FTSForm,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    dragOptions: commons.dragOptions,
    listDesignForm: {
      rows: [ 
        {
          items: [
            {
              displayName: "Label",
              fieldName: "label",
              input: "text",
              type: 0
            },
            {
              displayName: "Width",
              fieldName: "width",
              input: "number",
              type: 3
            },
          ],
        },
        {
          items: [
            {
              displayName: "Wrap",
              fieldName: "wrap",
              input: "boolean",
              type: 1
            },      
          ],
        },
      ]      
    },
    informationModal: false,
    formData: null
  }),
  methods: {
    //GET
    getIcon(typeId) {
      if (typeId === "state" || typeId === "collaboration") 
        typeId = 7

      return commons.informationIcon(typeId);
    },
    remove(item) {
      if(this.removeable)
        this.$emit('remove', item)
      else
        this.hideColumn(item)
    },
    showColumn(item) {
      this.$delete(item, 'hide')
    },
    hideColumn(item) {
      this.$set(item, 'hide', true)
    },
    openModal() {
      this.formData = _.cloneDeep(this.item);
      this.informationModal = true
    },
    doneModal() {
      this.$emit('update', this.formData)
      this.informationModal = false
    },
    closeModal() {
      this.informationModal = false
    }
  },
  computed: {   
    getSelectionPrefix() {
      return queryLogic.querySelectionPrefix.find(x => x.id === this.item.id) ? true : false
    }
  },
  beforeCreate: function () {
		this.$options.components.FtsListDesignerLayouter = require('./FTSListDesignerLayouter').default
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";
.fts-list-designer-element {
  display: flex;
  border: 1px solid #f5f5f5;
  background: #fff;
  .list-designer-element-wrapper {
    padding: .575rem .75rem;
    .list-designer-element-item {
      display: flex;
      align-items: center;
      &.selection-prefix {
        .list-designer-element-icon {
          color: $primaryColor;
        }
      }
      &:not(.selection-prefix) {
        .list-designer-element-icon {
          color: $secondaryColor;
        }
      }
      .list-designer-element-icon {
        margin-right: .575rem;
        font-size: 90%;
      }
      .list-designer-element-name {
        font-size: .875rem;
        &:hover {
          cursor: grab;
        }
      }
      .list-designer-element-badge {
        margin-left: .375rem;
      }
    }

    .list-designer-element-columns {
      margin-top: .275rem;
    }

    .list-designer-element-control {
      display: flex;
      margin-top: .275rem;
      .list-designer-element-control-container {
        display: flex;
        align-items: center;
        margin: -.275rem;
        .list-designer-element-control-wrapper {
          margin: .275rem;
          &.element-control-active {
            // fontawesome icon
            svg {
              color: $primaryColor;
            }
          }
          .element-control-edit {
            &:hover {
              color: $primaryColor;
            }
          }
          .element-control-badge {
            padding: 2px 6px;
            border-radius: 2px;
            font-size: .575rem;
            font-weight: bold;
            background: $grayLightenColor;
          }
          // fontawesome icon
          svg {
            font-size: .875rem;
            color: $grayLightColor;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .list-designer-element-remove {
    svg {
      margin: .675rem .475rem 0;
      font-size: .75rem;
      color: $grayLightColor;
      &:hover {
        color: $dangerColor;
        cursor: pointer;
      }
    }
  }

  .list-designer-element-modal {
    .element-modal-header {
      min-width: 0;
      display: flex;
      align-items: center;
      .element-modal-info-icon {
        margin-right: .575rem;
        font-size: 1.25rem;
        &.system {
          color: $primaryColor;
        } 
        &:not(.system) {
          color: $secondaryColor;
        }
      }
    }
    .element-modal-columns {
      margin: .375rem;
      .element-modal-label {
        font-size: .75rem;
        font-weight: bold;
      }
      .element-modal-column-wrapper {
        display: flex;
        align-items: center;
        margin: .75rem 0;
        padding: .575rem .75rem;
        cursor: pointer;
        &.column-selected {
          box-shadow: 0 1px 2.5px 0 rgba(0, 0, 0, 0.16), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          background: #fff;
          .element-modal-column-item {
            .element-modal-column-indicator {
              color: $successColor;
            }
          }
        }
        &:not(.column-selected) {
          background: $grayLightenColor;
          color: $grayLightColor;
          .element-modal-column-item {
            .element-modal-column-icon {
              filter: grayscale(1);
            }
          }
        }
        .element-modal-column-handle {
          margin-right: .375rem;
          font-size: .75rem;
          color: $grayLightColor;
          cursor: grab;
        }
        .element-modal-column-item {
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 1.5rem;
          .element-modal-column-icon {
            position: absolute;
            top: 1px;
            left: 0;
            font-size: 1.2rem;
            color: $secondaryColor;
          }
          .element-modal-column-name {
            font-size: .875rem;
          }
          .element-modal-column-indicator {
            color: $grayLightenColor;
          }
        }
      }
    }
  }
}
</style>